import React, { useEffect, useState } from 'react';

import { TableCell, TableHead, TableRow, Checkbox } from '@material-ui/core';
import { useContestSetupState } from '../../../Context/ContestSetup.context';

interface HeadCell {
  align: 'left' | 'center' | 'right';
  disablePadding: boolean;
  id: 'fullName' | 'hdcp' | 'flight';
  label: string;
  numeric: boolean;
}

const headCells: HeadCell[] = [
  { align: 'left', id: 'fullName', numeric: false, disablePadding: true, label: 'Player' },
  { align: 'center', id: 'hdcp', numeric: true, disablePadding: false, label: 'HDCP' },
  { align: 'left', id: 'flight', numeric: true, disablePadding: false, label: 'Flight' }
];

interface ContestSetupTableProps {
  onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
  rowCount: number;
}

export const ContestSetupTableHead = (props: ContestSetupTableProps): JSX.Element => {
  const { onSelectAllClick, rowCount } = props;

  const { selectedLeaderboard } = useContestSetupState();

  const numSelected = selectedLeaderboard ? selectedLeaderboard.enrollments.length : 0;

  const [allPlayersAreSelected, setAllPlayersAreSelected] = useState(false);

  useEffect(() => {
    setAllPlayersAreSelected(rowCount > 0 && numSelected === rowCount);
  }, [rowCount, numSelected, rowCount]);

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          {!allPlayersAreSelected && (
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={allPlayersAreSelected}
              disabled={allPlayersAreSelected}
              onChange={onSelectAllClick}
              inputProps={{ 'aria-label': 'select all desserts' }}
              color="primary"
              classes={{ root: 'select-all-checkbox' }}
            />
          )}
        </TableCell>

        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.align}
            padding={headCell.disablePadding ? 'none' : 'default'}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
